// frontend/src/askos/liveSessions/SessionFeedbackModal.js
//
// Post-session CSAT prompt: 1-5 rating + optional comment.
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { submitLiveSessionFeedback } from '../../api/liveSessionsApi';

const SessionFeedbackModal = ({ show, slug, sessionId, onClose, onSubmitted }) => {
    const [rating, setRating] = useState(0);
    const [comments, setComments] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const submit = async () => {
        if (!rating) {
            setError('Please select a rating.');
            return;
        }
        setSubmitting(true);
        setError('');
        try {
            await submitLiveSessionFeedback(slug, sessionId, rating, comments);
            onSubmitted && onSubmitted();
            onClose();
        } catch (err) {
            setError(err.response?.data?.detail || 'Could not submit feedback.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>How was this session?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <p className="text-danger small">{error}</p>}
                <div className="d-flex gap-2 mb-3 justify-content-center">
                    {[1, 2, 3, 4, 5].map(n => (
                        <button
                            key={n}
                            type="button"
                            onClick={() => setRating(n)}
                            style={{
                                fontSize: 28, background: 'none', border: 'none', cursor: 'pointer',
                                color: n <= rating ? '#f1a51c' : '#ccc',
                            }}
                            aria-label={`Rate ${n} star${n > 1 ? 's' : ''}`}
                        >
                            ★
                        </button>
                    ))}
                </div>
                <Form.Group>
                    <Form.Label className="small text-muted">Any comments? (optional)</Form.Label>
                    <Form.Control as="textarea" rows={3} value={comments} onChange={e => setComments(e.target.value)} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>Skip</Button>
                <Button onClick={submit} disabled={submitting}>Submit Feedback</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SessionFeedbackModal;
